export default __webpack_public_path__ + "static/img_welfare_11-63ff717891b5d0f55d8ba71e0c0415fe.jpg";